import AppPaginator from "./AppPaginator.vue";

export default AppPaginator;
